export default __webpack_public_path__ + "assets/9ce6744cd6b9c82b8e91054f1e06b1e2.svg";